import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { Link, Redirect } from 'react-router-dom';
import { ListHeader, ListPaging, CardList } from './components';
import { useDispatch } from 'react-redux';
import { getThemes } from '../redux/actions/actTheme';
import { useSelector } from 'react-redux';
import { isAuth } from '../auth/actions';


export default function Template() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const [inputSearch, setInputSearch] = useState('');
  const [sortBy, setSortBy] = useState('');
  
  let contentUi = <div className='loader-block' />;

    contentUi = (
      <React.Fragment>
        <CardList search={inputSearch} sort={sortBy} />
        <ListPaging />
      </React.Fragment>
    );
  
  //handleSearch
  const handleSearch = (event) => {
    setInputSearch(event.target.value);
  };
  const handleSortBy = (event) => {
    setSortBy(event.target.value);
  };

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      {isAuth() ? (
        <main className='workspace'>
          <section className='breadcrumb lg:flex items-start'>
            <div>
              <h1>List of Templates</h1>
              <ul>
                <li>
                  <Link to='/theme-management'>Home</Link>
                </li>
                <li className='divider la la-arrow-right'></li>
                <li>List of Templates</li>
              </ul>
            </div>
            <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
              <form
                onSubmit={handleSearch}
                className='flex items-center lg:ml-2 mt-5 lg:mt-0'
                action='#'
              >
                <label className='form-control-addon-within rounded-full border-secondary'>
                  <input
                    type='text'
                    className='form-control border-none'
                    placeholder='Input template name'
                    // onChange={(event) => setSearch(event.target.value)}
                    value={inputSearch}
                    onChange={handleSearch}
                  />
                  <button
                    type='submit'
                    className='btn btn-link text-secondary dark:text-gray-700 hover:text-primary dark:hover:text-primary text-xl leading-none la la-search mr-4'
                  ></button>
                </label>
              </form>

              <div className='flex mt-5 lg:mt-0'>
                <div className='dropdown lg:ml-2'>
                  <select
                    id='sortby'
                    name='sortby'
                    onChange={handleSortBy}
                    className='mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full'
                  >
                    <option defaultChecked value='' disabled>
                      Sort by
                    </option>
                    <option value=''>All Template</option>
                    <option value='FORMS'>Forms</option>
                    <option value='QUIZ'>Quiz</option>
                    <option value='SURVEY'>Survey</option>
                  </select>
                </div>

                <Link
                  to={`/template-management/add`}
                  className='btn btn_primary uppercase ml-2'
                >
                  Add New Template
                </Link>
              </div>
            </div>
          </section>

          {contentUi}

          <Footer />
        </main>
      ) : (
        <Redirect to='/auth' />
      )}
    </div>
  );
}
